import React from 'react';
import styled from 'styled-components';
import { FaPlay } from 'react-icons/fa';

const SermonsSection = styled.section`
  background-color: #fff;
  width: 100%;

  @media (max-width: 768px) {
    display: grid;
    justify-content: center;
    align-items: start;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  color: #ea384c;
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 3rem;
  opacity: 0;
  animation: fadeIn 0.5s ease-out forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const SermonsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
`;

const SermonCard = styled.div`
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  }
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  background-color: #fff1f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  svg {
    color: #ea384c;
    font-size: 1.5rem;
  }
`;

const SermonTitle = styled.h3`
  color: #ea384c;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const SermonDescription = styled.p`
  color: #4b5563;
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;

const WatchButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ea384c;
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #dc2626;
  }

  svg {
    margin-right: 0.5rem;
    font-size: 0.875rem;
  }
`;

const VideoCard = styled(SermonCard)`
  position: relative;
  padding: 0;
  overflow: hidden;
  aspect-ratio: 16/9;
  cursor: pointer;
`;

const VideoThumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url('https://images.unsplash.com/photo-1605810230434-7631ac76ec81');
  background-size: cover;
  background-position: center;
`;

const PlayOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;

  svg {
    color: white;
    font-size: 3rem;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

const sermonsData = [
  {
    title: 'Faith Over Fear',
    description: 'Discover how faith can overcome any fear in your life.',
    link: '#',
  },
  {
    title: 'The Power of Prayer',
    description: 'Learn how prayer strengthens our relationship with God.',
    link: '#',
  },
  {
    title: 'Walking in Grace',
    description: 'Embrace Gods grace in your daily walk.',
    link: '#',
  },
  {
    title: 'Walking in Love',
    description: 'Embrace Gods grace in your daily walk.',
    link: '#',
  },
  {
    title: 'Walking in Faith',
    description: 'Embrace Gods grace in your daily walk.',
    link: '#',
  },
];

const Sermons = () => {
  return (
    <SermonsSection id='sermons'>
      <Container>
        <SectionTitle>Latest Sermons</SectionTitle>
        <SermonsGrid>
          <VideoCard>
            <VideoThumbnail>
              <PlayOverlay>
                <FaPlay />
              </PlayOverlay>
            </VideoThumbnail>
          </VideoCard>
          {sermonsData.map((sermon, index) => (
            <SermonCard key={index}>
              <IconWrapper>
                <FaPlay />
              </IconWrapper>
              <SermonTitle>{sermon.title}</SermonTitle>
              <SermonDescription>{sermon.description}</SermonDescription>
              <WatchButton href={sermon.link}>
                <FaPlay /> Watch Now
              </WatchButton>
            </SermonCard>
          ))}
        </SermonsGrid>
      </Container>
    </SermonsSection>
  );
};

export default Sermons;